import { Children, isValidElement, useEffect } from "react";
import type { ReactElement, ReactNode } from "react";

function findTitle(children: ReactNode): string | null {
  for (const child of Children.toArray(children)) {
    if (!isValidElement(child)) continue;
    const element = child as ReactElement<{ children?: ReactNode }>;
    if (element.type === "title") return Children.toArray(element.props.children).join("");
  }
  return null;
}

/** Títulos dos <Head> montados, em ordem de montagem: o último vence (como no next/head). */
const titleStack: Array<{ title: string }> = [];

function applyTitle(): void {
  const top = titleStack[titleStack.length - 1];
  if (top) document.title = top.title;
}

/** Substituto do next/head: só aplica <title>; metas fixas ficam no index.html. */
export default function Head({ children }: { children?: ReactNode }) {
  const title = findTitle(children);
  useEffect(() => {
    if (title === null) return;
    const entry = { title };
    titleStack.push(entry);
    applyTitle();
    return () => {
      titleStack.splice(titleStack.indexOf(entry), 1);
      applyTitle();
    };
  }, [title]);
  return null;
}
